import {
  Container,
  Typography,
  Chip,
  Avatar,
  Box,
  Stack,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";
import {
  CalendarMonth,
  AccessTime,
  ArrowBack,
  Person,
} from "@mui/icons-material";
import { Link, useParams, Navigate } from "react-router-dom";
import { useEffect, } from "react";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import {
  getBlogDetailBySlug,
  getBlogsCategories,
} from "../../features/user/userSlice.js";
import Loader from "../../components/common/Loader.jsx";

import Seo from "../../components/Seo";
import placeholderImage from "../../assets/placeholder-image.jpg"

import Breadcrumb from "../../components/Breadcrumb";
import { generateBreadcrumbs } from "../../utils/breadcrumbs";

export default function BlogDetail() {
  const dispatch = useDispatch();
  const { blogDetail, blogsCategories, blogsLoading, blogError } = useSelector(
    (state) => state.user
  );
  const { slug } = useParams();
  // const [isLiked, setIsLiked] = useState(false);
  // const [isBookmarked, setIsBookmarked] = useState(false);

  // console.log("Blog Detail:", blogDetail);

  /*useEffect(() => {
    dispatch(getBlogsCategories());
    if (slug) {
      dispatch(getBlogDetailBySlug(slug));
    }
  }, [slug, dispatch]);*/


    /*useEffect(() => {
    window.prerenderReady = false; // tells Prerender to wait

    // fetch blog categories
    dispatch(getBlogsCategories());

    if (slug) {
      // fetch blog detail
      dispatch(getBlogDetailBySlug(slug)).then(() => {
        // mark prerender ready after a short delay to ensure meta tags update
        setTimeout(() => {
          window.prerenderReady = true;
        }, 200);
      });
    }
  }, [slug, dispatch]);*/

    /*useEffect(() => {
    console.log("Prerender: ready = false");
    window.prerenderReady = false;

    if (slug) {
      dispatch(getBlogDetailBySlug(slug)).then(() => {
        setTimeout(() => {
          window.prerenderReady = true;
          console.log("Prerender: ready = true");
        }, 1000);
      });
    }
  }, [slug, dispatch]);*/


  useEffect(() => {
    window.prerenderReady = false;

    if (slug) {
      Promise.all([
        dispatch(getBlogDetailBySlug(slug)),
        dispatch(getBlogsCategories())
      ]).then(() => {
        // Wait a little extra to ensure DOM updates
        setTimeout(() => {
          window.prerenderReady = true;
          console.log("Prerender: ready = true");
        }, 1000); // increase delay to 500ms
      });
    }
  }, [slug, dispatch]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [slug]);

  if (!slug) return <Navigate to="/" replace />;
  const post = blogDetail;
  // .find(p => p.slug === slug );
  // && p.status === 'published'

  const getCategoryName = (categoryId) =>
    blogsCategories.find((cat) => cat.id === categoryId)?.name ||
    "Uncategorized";

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  const getReadingTime = (content) => {
    const words = content.replace(/<[^>]*>/g, "").split(" ").length;
    return `${Math.ceil(words / 200)} min read`;
  };

  // const handleShare = async () => {
  //   if (navigator.share) {
  //     try {
  //       await navigator.share({
  //         title: post.title,
  //         text: post.excerpt,
  //         url: window.location.href,
  //       });
  //     } catch (err) {
  //       console.error("Error sharing:", err);
  //     }
  //   } else {
  //     navigator.clipboard.writeText(window.location.href);
  //   }
  // };

  const breadcrumbs = generateBreadcrumbs({ pageType: "blog", data: post });

  if (blogsLoading || !blogDetail || !blogDetail.id) {
    return (
      <Box
        sx={{
          minHeight: "100vh", // ensures the loader fills the viewport
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "background.default",
        }}
      >
        <Loader />
      </Box>
    );
  }

  // Show not found only if loading is done and post is missing or invalid
  if (blogError || !blogDetail || !blogDetail.id) {
    return (
      <Typography variant="h6" sx={{ m: 4 }}>
        Post not found.
      </Typography>
    );
  }
  // console.log('related_articles:',blogDetail.related_articles)
  const relatedPosts = Array.isArray(blogDetail?.related_articles)
    ? blogDetail.related_articles
        .filter((p) => p.id !== blogDetail.id)
        .slice(0, 3)
    : [];

  //&& p.category_id === post.category_id
  // && p.status === "published"

  return (
    <>
      {/* SEO & Schema.org */}
      <Seo
        title={post.title}
        description={post.excerpt || post.meta_description || ""}
        url={`https://scraptrade.com.au/blog/${post.slug}`}
        canonical={`https://scraptrade.com.au/blog/${post.slug}`}
        image={
          post.feature_image_url ||
          "https://scraptrade.com.au/assets/og/default.jpg"
        }
        breadcrumbs={breadcrumbs}
        extraSchema={{
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          headline: post.title,
          description: post.excerpt,
          image:
            post.feature_image_url ||
            "https://scraptrade.com.au/assets/og/default.jpg",
          author: {
            "@type": "Person",
            name: post.author?.name || "ScrapTrade",
          },
          publisher: {
            "@type": "Organization",
            name: "ScrapTrade",
            logo: {
              "@type": "ImageObject",
              url: "https://scraptrade.com.au/assets/logo.png",
            },
          },
          mainEntityOfPage: {
            "@type": "WebPage",
            "@id": `https://scraptrade.com.au/blog/${post.slug}`,   
          },
          datePublished: post.created_at,
          dateModified: post.updated_at || post.created_at,
        }}
      />

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <Container maxWidth="md" sx={{ py: 6 }}>
          <Box sx={{ mb: 2 }}>
            <Link
              to="/blog"
              style={{
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                color: "#666",
              }}
            >
              <ArrowBack sx={{ mr: 1 }} />
              Back to articles
            </Link>
          </Box>

          {/* Breadcrumbs */}
          <Breadcrumb items={breadcrumbs} />

          <Stack direction="row" spacing={2} sx={{ mb: 2 }} alignItems="center">
            <Chip
              label={getCategoryName(post.category_id)}
              color="warning"
              variant="outlined"
            />
            <Stack direction="row" spacing={1} alignItems="center">
              <CalendarMonth fontSize="small" />
              <Typography variant="body2">
                {formatDate(post.created_at)}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <AccessTime fontSize="small" />
              <Typography variant="body2">
                {getReadingTime(post.content)}
              </Typography>
            </Stack>
          </Stack>

          <Typography
            variant="h4"
            component="h1"
            sx={{ fontWeight: "bold", mb: 2 }}
          >
            {post.title}
          </Typography>

          <Typography
            variant="subtitle1"
            sx={{ color: "text.secondary", mb: 4 }}
          >
            {post.excerpt}
          </Typography>

          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ mb: 4 }}
          >
            <Stack direction="row" alignItems="center" spacing={2}>
              <Avatar
                src={post.author.profile_image_url}
                alt={post.author.name}
                sx={{
                  objectFit: "contain", // ensures full image fits inside
                  bgcolor: "transparent", // optional, removes default bg color
                }}
              />

              <Stack>
                <Typography
                  variant="body2"
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Person fontSize="small" sx={{ mr: 0.5 }} />
                  {post.author.name}
                </Typography>
              </Stack>
            </Stack>
            {/* <Stack direction="row" spacing={1}>
            <IconButton
              onClick={() => setIsLiked(!isLiked)}
              color={isLiked ? 'error' : 'default'}
              sx={{ transition: '0.3s', '&:hover': { transform: 'scale(1.1)' } }}
            >
              <Favorite />
            </IconButton>
            <IconButton
              onClick={() => setIsBookmarked(!isBookmarked)}
              color={isBookmarked ? 'warning' : 'default'}
              sx={{ transition: '0.3s', '&:hover': { transform: 'scale(1.1)' } }}
            >
              <Bookmark />
            </IconButton>
            <IconButton
              onClick={handleShare}
              sx={{ transition: '0.3s', '&:hover': { transform: 'scale(1.1)' } }}
            >
              <Share />
            </IconButton>
          </Stack> */}
          </Stack>

          {post.feature_image_url && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              <CardMedia
                component="img"
                image={post.feature_image_url || placeholderImage}
                alt={post.title}
                loading="lazy"
                sx={{ height: 400, borderRadius: 2, mb: 4, boxShadow: 3 }}
              />
            </motion.div>
          )}

          <Box
            sx={{
              bgcolor: "background.paper",
              p: 4,
              borderRadius: 2,
              mb: 6,
              boxShadow: 1,
              transition: "0.3s",
              "&:hover": { boxShadow: 4 },
            }}
          >
            <div
              dangerouslySetInnerHTML={{ __html: post.content }}
              style={{
                lineHeight: "1.8",
                fontSize: "1.1rem",
                color: "#444",
              }}
            />
          </Box>

          {relatedPosts.length > 0 && (
            <Box>
              <Typography variant="h5" sx={{ fontWeight: "bold", mb: 3 }}>
                Related Articles
              </Typography>
              <Stack spacing={3}>
                {relatedPosts.map((rel) => (
                  <motion.div
                    key={rel.id}
                    whileHover={{ scale: 1.02 }}
                    transition={{ type: "spring", stiffness: 200 }}
                  >
                    <Card
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        overflow: "hidden",
                        boxShadow: 2,
                      }}
                    >
                      <CardMedia
                        component="img"
                        image={rel.feature_image_url}
                        alt={rel.title}
                        loading="lazy"
                        sx={{ width: 150, objectFit: "cover" }}
                      />
                      <CardContent sx={{ flex: 1 }}>
                        {/* {console.log("slug:", rel.slug)} */}
                        <Link
                          to={`/blog/${rel.slug}`}
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          <Typography variant="h6" gutterBottom>
                            {rel.title}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {rel.excerpt}
                          </Typography>
                        </Link>
                      </CardContent>
                    </Card>
                  </motion.div>
                ))}
              </Stack>
            </Box>
          )}
        </Container>
      </motion.div>
    </>
  );
}
